export type NumberNotation = 'standard' | 'compact'

export const formatNumberValue = (
  value: number,
  notation: NumberNotation = 'standard',
  style: 'decimal' | 'percent' = 'decimal',
  maximumFractionDigits = 1,
  locale: Intl.LocalesArgument = 'en-GB',
  minimumFractionDigits = 0,
): string => {
  const formatted = new Intl.NumberFormat(locale, {
    notation,
    style,
    minimumFractionDigits: Math.min(minimumFractionDigits, maximumFractionDigits),
    maximumFractionDigits,
  }).format(value)

  return notation === 'compact' ? formatted.toUpperCase() : formatted
}
